import {withRouter} from 'react-router-dom';
import {Col, Row} from 'react-bootstrap';
import {Button, Form, Switch, notification} from "antd";
import UserInfo from "../auth/UserInfo";
import HelperGeneral from "../../helpers/HelperGeneral";
import {setGlobalSpinner} from "../../services/redux/actions/GeneralAction";
import Api from "../../services/Api";

const ContactPreferences = () => {
    const [form] = Form.useForm();
    const user = UserInfo.info();

    const onFinishUpdate = (values) => {
        setGlobalSpinner(true);

        const data = {
            permission_sms: values?.permission_sms ?? false,
            permission_email: values?.permission_email ?? false,
            permission_call: values?.permission_call ?? false,
        };

        Api.contactPreferences(data).then(r => {
            Api.getCustomer().then(r2 => {
                const {remember} = UserInfo.dataCheck();
                UserInfo.setUserInfo(r2?.data, remember);
                setGlobalSpinner(false)
                notification['success']({
                    message: 'Başarılı!',
                    description: 'İletişim tercihleriniz güncellenmiştir.',
                });
            }).catch((e) => {
                setGlobalSpinner(false)
                HelperGeneral.alert(e)
            });
        }).catch((e) => {
            setGlobalSpinner(false)
            HelperGeneral.alert(e)
        })
    }

    return (
        <div className={'box profile contact-preferences'}>
            <h2 className={'margin'}>İletişim Tercihlerim</h2>
            <p>
                Kampanyalardan haberdar olmak için, KVKK Aydınlatma Metni ve Açık Rıza Beyanı kapsamında tercih ettiğiniz iletişim yöntemlerini seçebilirsiniz.
            </p>
            <Form
                form={form}
                layout={'horizontal'}
                initialValues={user}
                onFinish={(e) => {
                    return onFinishUpdate(e)
                }}
            >
                <Row>
                    <Col xs={4} sm={12} md={4}>
                        <Form.Item label={"SMS"} name={"permission_sms"} valuePropName={"checked"}>
                            <Switch/>
                        </Form.Item>
                    </Col>
                    <Col xs={4} sm={12} md={4}>
                        <Form.Item label={"E-posta"} name={"permission_email"} valuePropName={"checked"}>
                            <Switch/>
                        </Form.Item>
                    </Col>
                    <Col xs={4} sm={12} md={4}>
                        <Form.Item label={"Cep Telefonu"} name={"permission_call"} valuePropName={"checked"}>
                            <Switch/>
                        </Form.Item>
                    </Col>
                    <Col xs={12}>
                        <p className={"text-center"}>
                            KVKK Aydınlatma Metnini okumak için <a href={"/kvkk-aydinlatma-metni"} target={"_blank"} className={'shiniq-custom-hover-color'}>tıklayınız</a>
                        </p>
                    </Col>
                    <Col xs={12}>
                        <p className={"text-center"}>
                            Ticari Elektronik İleti Bilgilendirme Metnini okumak için <a href={"/ticari-elektronik-ileti"} target={"_blank"} className={'shiniq-custom-hover-color'}>tıklayınız</a>
                        </p>
                    </Col>
                    <Col xs={12}>
                        <p className={"text-center"}>
                            Açık Rıza Beyanını okumak için <a href={"/acik-riza-beyani"} target={"_blank"} className={'shiniq-custom-hover-color'}>tıklayınız</a>
                        </p>
                    </Col>
                    <Col xs={12} className={'mx-auto'}>
                        <Form.Item className={'mb-1'}>
                            <Button type={"primary"} htmlType={'submit'}>Güncelle</Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}

export default withRouter(ContactPreferences);
